module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "pageiii"
    }
  }), _vm._v("Family Favorite"), _c('br'), _vm._v("Casserole Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "titletext"
  }, [_c('strong', [_c('em', [_vm._v("103 Comforting Breakfast Casseroles,"), _c('br'), _vm._v("Dinner Ideas, and Desserts"), _c('br'), _vm._v("Everyone Will Love")])])]), _vm._v(" "), _c('h4', {
    staticClass: "authora"
  }, [_vm._v("Addie Gundry")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fb58e3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 60
// module chunks = 0